import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useCashDiscountApi() {
    const callApi = useApiCall();

    return {
        getCashDiscountSettings: apiCaller(callApi, SAGA_ACTIONS.CASH_DISCOUNT.GET),
        insertUpdateCashDiscountSettings: apiCaller(callApi, SAGA_ACTIONS.CASH_DISCOUNT.INSERT_UPDATE),
    };
}
